<template>
  <div class="rank_cell after_border">
    <div class="idx" :class="'rank' + rank">{{ rank }}</div>
    <img v-lazy="data.user.avatar_url" class="headimg">
    <div class="username">{{ data.user.nickname }}</div>
    <div class="times">{{ data.rank_field }}{{ rankCode | rankLabel }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RankCell',
  components: {
  },
  props: {
    rankCode: {
      type: String,
      default: 'day'
    },
    rank: {
      type: Number,
      default: 1
    },
    data: {
      type: Object,
      default () {
        return null
      }
    }
  },
  filters: {
    rankLabel (value) {
      if (value === 'day') {
        return '天'
      } else if (value === 'distance') {
        return '公里'
      } else if (value === 'duration') {
        return ''
      } else if (value === 'pace') {
        return ''
      } else if (value === 'num') {
        return '次'
      }
      return ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ])
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.rank_cell {
  font-size: 26px;
  padding: 0 30px;
  height: 110px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .idx {
    font-size: 26px;
    width: 40px;
    &.rank1 {
      color: #ffdc7b;
      font-weight: bold;
      font-size: 30px;
    }
    &.rank2 {
      color: #d8efed;
      font-weight: bold;
      font-size: 30px;
    }
    &.rank3 {
      color: #f6d6bc;
      font-weight: bold;
      font-size: 30px;
    }
  }
  .headimg {
    width: 77px;
    height: 77px;
    border-radius: 50%;
  }
  .username {
    font-size: 28px;
    width: 450px;
  }
  .times {
    color: #8d8d8d;
  }
}
</style>
